import { takeEvery, put, call } from "redux-saga/effects";
import { showError } from "../../utils/helper";
import { SUBMIT_NPS, NPS_HANDLE } from "../action/types";
import {
  submitNpsSuccess,
  submitNpsFailure,
  npsHandleSuccess,
  npsHandleFailure,
} from "../action/surveyAction";
import USERS from "../../utils/api/users";
import { toast } from "react-toastify";

function* submitNpsRequest(action) {
  const { payload, onSuccess, onFailure } = action.payload || {};
  const { productId, responses: apiPayload } = payload || {};
  const submitBody = { productId, responses: apiPayload };
  try {
    const res = yield USERS.post("users/nps/submit", submitBody);
    if (res.status === 200 || res.status === 201) {
      const { message, category } = res.data || {};
      const successMessage = [
        message || "Feedback submitted successfully",
        category,
      ]
        .filter(Boolean)
        .join(" • ");
      toast.success(successMessage);
      yield put(submitNpsSuccess());
      if (onSuccess) yield call(onSuccess);
    } else {
      yield put(submitNpsFailure());
      if (onFailure) yield call(onFailure);
    }
  } catch (e) {
    yield put(submitNpsFailure());
    yield call(showError, e);
    if (onFailure) yield call(onFailure);
  }
}

function* npsHandleRequest(action) {
  const {
    action: npsAction,
    productId,
    onSuccess,
    onFailure,
  } = action.payload || {};

  // Only proceed if productId is available
  if (!productId) {
    return;
  }

  try {
    const handlePayload = { action: npsAction, productId };
    const res = yield USERS.post("users/nps/handle", handlePayload);
    const result = res.data?.result;
    if (res.status === 200 || res.status === 201) {
      yield put(npsHandleSuccess(result || {}));
      if (onSuccess) yield call(onSuccess);
    } else {
      yield put(npsHandleFailure());
      if (onFailure) yield call(onFailure);
    }
  } catch (e) {
    yield put(npsHandleFailure());
    yield call(showError, e);
    if (onFailure) yield call(onFailure);
  }
}

export default function* surveySaga() {
  yield takeEvery(SUBMIT_NPS, submitNpsRequest);
  yield takeEvery(NPS_HANDLE, npsHandleRequest);
}
